export {
  notificationsApi2,
  useGetNotificationsQuery,
  useLazyGetNotificationsQuery,
  useGetUnreadCountQuery,
  useMarkAsReadMutation,
  useMarkAllAsReadMutation,
  useGetNotificationSettingsQuery,
  useUpdateNotificationSettingsMutation,
} from './api';
export {
  NotificationsEndpoints,
  NotificationChannel,
  type GetNotificationSettingsRequest,
  type GetNotificationSettingsResponse,
  type GetNotificationsRequest,
  type GetNotificationsResponse,
  type GetUnreadCountRequest,
  type GetUnreadCountResponse,
  type MarkAllAsReadRequest,
  type MarkAllAsReadResponse,
  type MarkAsReadRequest,
  type MarkAsReadResponse,
  type ModelNotification,
  type ModelNotificationSettingItem,
  type ModelUserNotificationSettings,
  type UpdateNotificationSettingsRequest,
  type UpdateNotificationSettingsResponse,
} from './types';
